<template>
  <v-container fluid grid-list-md class="header-container">
    <v-layout row wrap>
      <v-flex
        xs12
        pa-3
        class="
          header-content
          text-xs-center
          white--text
          headline
          font-weight-medium
        "
      >
        Clients
      </v-flex>
      <utility-backButton />
      <v-flex xs12>
        <!-- Add and editing Client Dialog vox-->
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              Editing Client: {{ selectedClient.Name }}
              <v-spacer />
              <v-icon @click="cancelEdit" color="pipefishOrange" medium
                >mdi-close-circle-outline</v-icon
              >
            </v-card-title>
            <v-card-text style="padding: 2px">
              <v-form ref="form" v-model="validation">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs4 pr-5>
                      <v-text-field
                        label="Client Name"
                        v-model="selectedClient.Name"
                        :value="selectedClient.Name"
                        :rules="[
                          !!selectedClient.Name || 'Name cannot be empty',
                        ]"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-avatar
                        v-if="
                          selectedClient.ImageUrl &&
                          selectedClient.ImageUrl.length > 0
                        "
                      >
                        <img
                          :src="selectedClient.ImageUrl"
                          style="backgroundcolor: white"
                        />
                      </v-avatar>

                      <v-avatar
                        v-if="
                          !selectedClient.ImageUrl ||
                          selectedClient.ImageUrl.length == 0
                        "
                      >
                        <span class="black--text headline">{{
                          AvatarName
                        }}</span>
                      </v-avatar>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        placeholder="Image Link"
                        label="Image Link"
                        v-model="selectedClient.ImageUrl"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <v-checkbox
                        label="Active"
                        v-model="selectedClient.IsActive"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex 6>
                      <color-picker
                        :theme="theme"
                        :color="selectedClient.Color"
                        :sucker-hide="true"
                        :colors-default="[]"
                        @changeColor="changeColor"
                      />
                    </v-flex>
                    <!-- <v-color-picker v-model="color" @update:color="updateColour"></v-color-picker> -->
                    <!-- <v-flex xs6>
                      <v-text-field
                        label="Client Color"
                        v-model="selectedClient.Color"
                        readonly
                        :color="`#${selectedClient.Color}`"
                      >
                      </v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
              <v-btn
                :disabled="!validation"
                color="pipefishGreen"
                @click="saveEdit"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- -----END----- -->

        <v-card-title>
          <!-- <span class="title font-weight-bold"> Clients </span> -->
          <v-spacer></v-spacer>
          <div>
            <v-flex xs12>
              <v-select
                dense
                hide-details
                :items="[
                  { text: 'Active', value: false },
                  { text: 'InActive', value: true },
                  { text: 'Both', value: 'Both' },
                ]"
                label="Filter on"
                v-model="filterActive"
              >
              </v-select>
            </v-flex>
          </div>
          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              hide-details
              color="pipefishGreen"
            >
              <template slot="label">
                <span>Search</span>
              </template>
            </v-text-field>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn left color="pipefishGreen" @click="addClient">Add</v-btn>
          </v-card-actions>
        </v-card-title>
        Total Shown: {{ clients.length }}
        <v-data-table
          v-if="clients != null"
          :headers="headers"
          :items="clients"
          :search="search"
          sort-icon="mdi-menu-down"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.Name }}</td>
            <td>{{ props.item.IsActive ? "active" : "inactive" }}</td>
            <td>
              <v-avatar>
                <img
                  v-if="props.item.ImageUrl && props.item.ImageUrl.length > 0"
                  :src="props.item.ImageUrl"
                  style="backgroundcolor: white"
                />
                <span
                  v-if="!props.item.ImageUrl || props.item.ImageUrl.length == 0"
                  class="headline"
                  >{{ generateAvatarName(props.item.Name) }}</span
                >
              </v-avatar>
            </td>
            <td>
              <div :style="`border: 5px solid #${props.item.Color}`"></div>
            </td>
            <td class="text-xs-right">
              <utility-editButton @edit="editClient(props.item)" />
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import colorPicker from "../components/color/Index.vue";
import imgCover from "../components/img/cover.jpg";

export default {
  components: {
    colorPicker,
  },
  data: () => ({
    filterActive: false,
    validation: true,
    isEdit: false,
    dialog: false,
    selectedClient: {
      Color: "#ffffff",
    },
    originalClient: {},
    search: "",
    hex: "#ffffff",
    headers: [
      { text: "Name", value: "Name" },
      { text: "Active", value: "IsActive", sortable: false },
      // {text: 'Id', value: 'Id', sortable: false},
      { text: "Image", value: "Image", sortable: false },
      { text: "Color", value: "Color", sortable: false },
      { text: "Action", value: "action", align: "right" },
    ],
    color: "#59c7f9",
    suckerCanvas: null,
    suckerArea: [],
    isOpenSucker: false,
    theme: "",
    inAnimation: false,
    // clients: data.clients
  }),
  computed: {
    // BUT WHAT IF THIS PAGE IS LOADED FIST AND CLIENT DATA IS NOT YET RECEIVED?
    ...mapState("api", ["clients", "projects", "timesheetData"]),
    clients: function () {
      return this.timesheetData.filter(
        (client) => client.IsActive != this.filterActive
      );
    },
    AvatarName: function () {
      if (this.selectedClient) {
        if (
          !this.selectedClient.ImageUrl ||
          this.selectedClient.ImageUrl.length == 0
        ) {
          return this.selectedClient.Name
            ? this.generateAvatarName(this.selectedClient.Name)
            : "";
        }
      }
      return "";
    },
  },
  created() {
    if (this.timesheetData.length == 0) {
      this.$router.push("/admin");
    }
  },
  methods: {
    ...mapMutations("api", ["setTimesheetData"]),
    rgb2hex({ r, g, b }, toUpper) {
      const change = (val) => ("0" + Number(val).toString(16)).slice(-2);
      const color = `#${change(r)}${change(g)}${change(b)}`;
      return toUpper ? color.toUpperCase() : color;
    },
    changeColor(color) {
      var hex = this.rgb2hex(color.rgba, true);
      // console.log(hex);
      this.selectedClient.Color = hex;
    },
    openSucker(isOpen) {
      this.isOpenSucker = isOpen;
      if (isOpen) {
        setTimeout(() => {
          const cover = this.$refs.cover;
          cover.onload = () => {
            // 如果已经点击取消了才加载完，则不执行
            if (!this.isOpenSucker) {
              return;
            }
            const coverRect = cover.getBoundingClientRect();
            const canvas = this.createCanvas(cover, coverRect);
            document.body.appendChild(canvas);
            this.suckerCanvas = canvas;
            this.suckerArea = [
              coverRect.left,
              coverRect.top,
              coverRect.left + coverRect.width,
              coverRect.top + coverRect.height,
            ];
          };
          cover.setAttribute("crossorigin", "Anonymous");
          cover.src = imgCover;
        }, 10);
      } else {
        this.suckerCanvas && this.suckerCanvas.remove();
      }
    },
    createCanvas(cover, coverRect) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = coverRect.width;
      canvas.height = coverRect.height;

      ctx.drawImage(cover, 0, 0, coverRect.width, coverRect.height);
      Object.assign(canvas.style, {
        position: "absolute",
        left: coverRect.left + "px",
        top: coverRect.top + "px",
        opacity: 0,
      });
      return canvas;
    },
    changeTheme() {
      this.theme = this.theme ? "" : "light";
      this.inAnimation = true;
    },
    animationEnd() {
      this.inAnimation = false;
    },

    editClient(client) {
      this.isEdit = true;
      this.selectedClient = client;
      Object.assign(this.originalClient, client);
      this.dialog = true;
    },
    addClient() {
      this.isEdit = false;
      this.selectedClient = { IsActive: true, Color: "#ffffff" };
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cancelEdit() {
      this.selectedClient.Name = this.originalClient.Name;
      this.selectedClient.IsActive = this.originalClient.IsActive;
      this.selectedClient.Color = this.originalClient.Color;
      this.selectedClient.ImageUrl = this.originalClient.ImageUrl;
      this.dialog = false;
      this.$refs.form.resetValidation();
    },
    saveEdit() {
      if (!this.$refs.form.validate()) {
        console.log("some fields are empty");
        return;
      }
      var self = this;
      if (this.isEdit) {
        this.$timesheetApi
          .updateClient(this.selectedClient)
          .then((response) => {
            // console.log(response)
            self.$timesheetApi.getData().then((masterData) => {
              self.setTimesheetData(masterData);
            });
          });
      } else {
        this.$timesheetApi.addClient(this.selectedClient).then((response) => {
          // console.log(response)
          self.$timesheetApi.getData().then((masterData) => {
            self.setTimesheetData(masterData);
          });
        });
      }
      this.dialog = false;
    },
    updateColour() {
      // console.log(this.hex);
      this.selectedClient.Color = this.hex;
    },
    generateAvatarName(name) {
      var sections = name.split(" ");
      var avatarName = "";
      for (var i = 0; i < sections.length; i++) {
        avatarName += sections[i].substring(0, 1).toUpperCase();
      }
      return avatarName;
    },
  },
};
</script>

<style>
</style>
